import React from 'react';
import PropTypes from 'prop-types';

import { TreeItem, TreeItemLayout, mergeClasses } from '@fluentui/react-components';
import { TooltipHost, TooltipOverflowMode } from '@bingads-webui-react/fabric-control';
import { TilesGridCellDropDecorator } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { CustomTab } from './custom-tab';

export const LeafTreeItem = ({
  value,
  level,
  setSize,
  posinset,
  onClick,
  classes,
  isSelected,
  content,
  parentValue,
  onDrop,
}) => (
  <TreeItem
    value={value}
    itemType="leaf"
    aria-level={level}
    aria-setsize={setSize}
    aria-posinset={posinset}
    onClick={onClick}
    parentValue={parentValue}
  >
    <TilesGridCellDropDecorator
      droppable={!isSelected}
      onDrop={onDrop}
      customClassName={classes.customDropDecorator}
    >
      <CustomTab
        value={value}
        classes={classes}
        isSelected={isSelected}
      >
        <TreeItemLayout className={mergeClasses(classes.treeItemLayout, isSelected && classes.treeSelected)}>
          <TooltipHost
            overflowMode={TooltipOverflowMode.Self}
            content={content}
            hostClassName={classes.tooltipHost}
          >
            {content}
          </TooltipHost>
        </TreeItemLayout>
      </CustomTab>
    </TilesGridCellDropDecorator>
  </TreeItem>
);

LeafTreeItem.propTypes = {
  value: PropTypes.number.isRequired,
  level: PropTypes.number.isRequired,
  setSize: PropTypes.number.isRequired,
  posinset: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    treeItemLayout: PropTypes.string,
    treeSelected: PropTypes.string,
    customDropDecorator: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
  parentValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onDrop: PropTypes.func.isRequired,
};

LeafTreeItem.defaultProps = {
  parentValue: null,
};
